import {Component} from '@angular/core';

@Component({
  selector: 'wv-blue-box',
  templateUrl: './blue-box.component.html',
  styleUrls: ['./blue-box.component.scss']
})
export class BlueBoxComponent {
}
